<template>
  <dara-aside-content-layout container-size="xxl">
    <template #aside>
      <dara-row>
        <dara-col>
          <dara-button v-if="user.permission > 0" class="mb--xl" @click="onCreateArticle">
            {{ $t('write-article') }}
          </dara-button>
          <dara-button class="mb--xl" @click="onCreateQuestion">
            {{ $t('add-question') }}
          </dara-button>
        </dara-col>
      </dara-row>
      <div class="mb--xl">
        <dara-home-writers />
      </div>
      <div class="mb--xl">
        <dara-home-followed-tags />
      </div>
      <div class="mb--xl">
        <dara-home-trending-tags />
      </div>
    </template>
    <template #content>
      <dara-modal-warning v-if="showModal" />
      <dara-home-tabs />
    </template>
  </dara-aside-content-layout>
</template>

<script>
import { goToCreateArticle } from '@/modules/article/article.routes';
import { goToCreateQuestion } from '@/modules/question/question.routes';
import { getters } from '@/modules/user/user.store';
import { USERS_ROLES } from '@/modules/user/user.constants';

import DaraAsideContentLayout from '@/layouts/AsideContentLayout.vue';
import DaraHomeWriters from '@/modules/home/components/HomeTopWriters.vue';
import DaraHomeFollowedTags from '@/modules/home/components/HomeFollowedTags.vue';
import DaraHomeTrendingTags from '@/modules/home/components/HomeTrendingTags.vue';
import DaraHomeTabs from '@/modules/home/components/HomeTabs.vue';

export default {
  name: 'DaraHomeLayout',
  components: {
    DaraAsideContentLayout,
    DaraHomeWriters,
    DaraHomeTabs,
    DaraHomeFollowedTags,
    DaraHomeTrendingTags,
  },
  data() {
    return {
      user: getters.getUser(),
      buttonName: '',
      iconName: 'plus',
      USERS_ROLES,
    };
  },
  computed: {
    showModal() {
      return window.location.host !== 'app.daraknows.com';
    },
  },
  methods: {
    onCreateArticle() {
      goToCreateArticle(this.$router);
    },
    onCreateQuestion() {
      goToCreateQuestion(this.$router);
    },
  },
};
</script>
